import React from 'react';
import { Receipt24Regular } from '@fluentui/react-icons';
import { SectionShell } from './SectionShell';
import { BillingAddressCard } from './BillingAddressCard';

// Standalone "Billing address" block: the SectionShell chrome around a
// BillingAddressCard. OrderDetails keeps its combined "Billing & rental period"
// section; this is for surfaces that want billing address on its own (e.g.
// ProjectDetails, where it's read-only and inherited from the customer).
interface BillingAddressSectionProps {
  savedBillingAddress: string | null;
  onAddBillingAddress?: () => void;
  onChangeBillingAddress?: () => void;
  onRemoveBillingAddress?: () => void;
  readOnly?: boolean;
  emptyLabel?: string;
  showIcon?: boolean;
}

const BillingAddressSectionBase: React.FC<BillingAddressSectionProps> = ({
  showIcon = true,
  ...cardProps
}) => (
  <SectionShell title="Billing address" icon={<Receipt24Regular />} showIcon={showIcon}>
    {/* BillingAddressCard's inner label defaults off — the SectionShell title
        already reads "Billing address", so the inner label is redundant. */}
    <BillingAddressCard {...cardProps} />
  </SectionShell>
);

export const BillingAddressSection = React.memo(BillingAddressSectionBase);
export default BillingAddressSection;
